import { useModalContext } from "@wingspanhq/fe-component-library";
import { VerificationStatus } from "@wingspanhq/users/dist/lib/interfaces";
import React from "react";
import { TIN_VERIFICATION_MODAL } from "../../../../Invoices/components/TINVerificationModal/TINVerificationModal";
import { useUserId } from "../../../../query/hooks/helpers";
import { useFeatureFlags } from "../../../../query/hooks/useFeatureFlags";
import { paymentsService } from "../../../../services/payments";
import { FormW9Concern } from "../../../../shared/components/FormW9Concern";
import { LayoutPaymentsSetup } from "../../../../shared/components/LayoutPaymentsSetup";
import { useMutationUpdateCurrentStep } from "../../mutations/useMutationUpdateCurrentStep";
import { RouteComponentProps } from "../../types";

export const RouteConsent: React.FC<RouteComponentProps> = ({
  onBack,
  onNext
}) => {
  const userId = useUserId();
  const { openModal } = useModalContext();
  const [updateCurrentStep] = useMutationUpdateCurrentStep();
  const queryFeatureFlags = useFeatureFlags();
  const runOldVerification = async () => {
    try {
      await paymentsService.service.update(userId, {
        verifications: { taxDocumentation: VerificationStatus.Verified }
      });
    } catch (error) {
      console.log("Failed to run old tax verification");
      console.log(error);
    }
  };

  return (
    <LayoutPaymentsSetup title="Certify your W-9 is accurate" onBack={onBack}>
      <FormW9Concern
        onSuccess={() => {
          if (queryFeatureFlags.data?.cip) {
            runOldVerification();
            updateCurrentStep({ newStep: 4 });
            onNext();
          } else {
            openModal(TIN_VERIFICATION_MODAL, {
              onContinue: () => {
                updateCurrentStep({ newStep: 4 });
                onNext();
              }
            });
          }
        }}
      />
    </LayoutPaymentsSetup>
  );
};
